
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <WhatsAppButton />

      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://sunandspeed.com/wp-content/uploads/2025/04/IMG_3231.webp"
            alt="About Us"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/70"></div>
        </div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-4">
            Sobre <span className="text-amber-400">Nosotros</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Líderes en alquiler de vehículos de lujo en México y Estados Unidos
          </p>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-white mb-6">
                Nuestra <span className="text-amber-400">Historia</span>
              </h2>
              <div className="space-y-4 text-gray-300 leading-relaxed">
                <p>
                  VIP Luxury Cars MKS nació de una pasión por los automóviles de lujo y el deseo de ofrecer 
                  experiencias inolvidables a nuestros clientes. Desde nuestros inicios en Cancún, 
                  México, nos hemos dedicado a proporcionar acceso a los vehículos más exclusivos 
                  y prestigiosos del mundo.
                </p>
                <p>
                  Con años de experiencia en la industria del alquiler de vehículos de lujo, hemos 
                  construido una reputación basada en la excelencia, la confiabilidad y el servicio 
                  al cliente excepcional. Cada vehículo en nuestra flota es cuidadosamente seleccionado 
                  y mantenido para garantizar la mejor experiencia posible.
                </p>
                <p>
                  Hoy, nos enorgullece expandir nuestros servicios a Estados Unidos, llevando la misma 
                  calidad y prestigio que nos caracteriza a nuevos destinos como Miami y Florida Keys.
                </p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://sunandspeed.com/wp-content/uploads/2025/04/PRINCIPAL-lamborghini-6-1.webp"
                alt="Luxury Car 1"
                className="w-full h-64 object-cover rounded-2xl"
              />
              <img
                src="https://sunandspeed.com/wp-content/uploads/2025/04/IMG_3231.webp"
                alt="Luxury Car 2"
                className="w-full h-64 object-cover rounded-2xl mt-8"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-black">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-amber-900/20 to-amber-800/10 rounded-2xl p-8 border border-amber-700/30">
              <div className="w-16 h-16 bg-amber-500/20 rounded-full flex items-center justify-center mb-6">
                <i className="ri-flag-line text-3xl text-amber-400"></i>
              </div>
              <h3 className="text-3xl font-bold text-white mb-4">Nuestra Misión</h3>
              <p className="text-gray-300 leading-relaxed">
                Proporcionar experiencias de conducción excepcionales a través del alquiler de 
                vehículos de lujo premium, combinando servicio personalizado, seguridad y la 
                emoción de conducir los automóviles más exclusivos del mundo. Nos comprometemos 
                a superar las expectativas de nuestros clientes en cada interacción.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-900/20 to-amber-800/10 rounded-2xl p-8 border border-amber-700/30">
              <div className="w-16 h-16 bg-amber-500/20 rounded-full flex items-center justify-center mb-6">
                <i className="ri-eye-line text-3xl text-amber-400"></i>
              </div>
              <h3 className="text-3xl font-bold text-white mb-4">Nuestra Visión</h3>
              <p className="text-gray-300 leading-relaxed">
                Ser la empresa líder en alquiler de vehículos de lujo en América Latina y Estados 
                Unidos, reconocida por nuestra flota excepcional, servicio impecable y compromiso 
                con la excelencia. Aspiramos a expandir nuestra presencia a los destinos más 
                exclusivos del continente.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-white mb-16">
            Nuestros <span className="text-amber-400">Valores</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-vip-crown-line text-4xl text-amber-400"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Excelencia</h3>
              <p className="text-gray-400">
                Nos esforzamos por la perfección en cada aspecto de nuestro servicio
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-4xl text-amber-400"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Confianza</h3>
              <p className="text-gray-400">
                Construimos relaciones duraderas basadas en la transparencia y honestidad
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-4xl text-amber-400"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Pasión</h3>
              <p className="text-gray-400">
                Amamos lo que hacemos y esa pasión se refleja en cada experiencia
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-star-line text-4xl text-amber-400"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Innovación</h3>
              <p className="text-gray-400">
                Constantemente mejoramos nuestros servicios para superar expectativas
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Fleet */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-black">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-4">
              Nuestra <span className="text-amber-400">Flota Premium</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Contamos con una selección exclusiva de las marcas más prestigiosas del mundo
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
            {[
              { name: 'Lamborghini', logo: 'https://sunandspeed.com/wp-content/uploads/2025/04/ASDFASDAFD.webp' },
              { name: 'Ferrari', logo: 'https://sunandspeed.com/wp-content/uploads/2025/04/asdonijapso-copia.webp' },
              { name: 'McLaren', logo: 'https://sunandspeed.com/wp-content/uploads/2025/04/aposdijfas-copia.webp' },
              { name: 'Porsche', logo: 'https://sunandspeed.com/wp-content/uploads/2025/04/japosdia.webp' },
              { name: 'Mercedes-Benz', logo: 'https://sunandspeed.com/wp-content/uploads/2025/04/Recurso-1sunspeed.webp' },
              { name: 'Land Rover', logo: 'https://sunandspeed.com/wp-content/uploads/2025/04/Land-Rover-Logo-Transparent-Image.webp' }
            ].map((brand) => (
              <div
                key={brand.name}
                className="bg-white/5 backdrop-blur-sm rounded-xl p-6 flex items-center justify-center hover:bg-white/10 transition-all"
              >
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="w-full h-16 object-contain filter brightness-0 invert opacity-80 hover:opacity-100 transition-opacity"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Locations */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-white mb-16">
            Nuestras <span className="text-amber-400">Ubicaciones</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gray-900 rounded-2xl p-8 border border-amber-900/30">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-amber-400"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-2">México</h3>
                  <p className="text-gray-400 mb-4">
                    Nuestras oficinas principales en el Caribe Mexicano
                  </p>
                </div>
              </div>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-400"></i>
                  <span>Cancún - Aeropuerto Internacional</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-400"></i>
                  <span>Cancún - Zona Hotelera</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-400"></i>
                  <span>Playa del Carmen</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-400"></i>
                  <span>Tulum</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-400"></i>
                  <span>Tulum - Aeropuerto</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-900 rounded-2xl p-8 border border-amber-900/30">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-amber-400"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-2">Estados Unidos</h3>
                  <p className="text-gray-400 mb-4">
                    Expandiendo nuestros servicios en Florida
                  </p>
                </div>
              </div>
              <ul className="space-y-3 text-gray-300">
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-400"></i>
                  <span>Miami - Aeropuerto Internacional</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-400"></i>
                  <span>Miami Beach</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-400"></i>
                  <span>Key West</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-amber-400"></i>
                  <span>Fort Lauderdale</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-black">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">
              Nuestro <span className="text-amber-400">Equipo</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Profesionales apasionados dedicados a brindarte la mejor experiencia
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                name: 'Carlos Rodríguez',
                position: 'Director General',
                description: 'Experto en la industria automotriz de lujo con más de 15 años de experiencia'
              },
              {
                name: 'María González',
                position: 'Gerente de Operaciones',
                description: 'Especialista en logística y servicio al cliente de alto nivel'
              },
              {
                name: 'Roberto Silva',
                position: 'Jefe de Flota',
                description: 'Apasionado por los superdeportivos y mantenimiento de vehículos premium'
              }
            ].map((member, index) => (
              <div
                key={index}
                className="bg-gray-900 rounded-2xl p-8 border border-amber-900/30 text-center"
              >
                <div className="w-24 h-24 bg-amber-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-user-line text-4xl text-amber-400"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{member.name}</h3>
                <p className="text-amber-400 font-semibold mb-4">{member.position}</p>
                <p className="text-gray-400 text-sm">{member.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-black">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            ¿Listo para Vivir la Experiencia?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Únete a miles de clientes satisfechos que han confiado en nosotros para sus experiencias de lujo
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/flota"
              className="bg-gradient-to-r from-amber-500 to-amber-600 text-black px-8 py-4 rounded-full font-bold hover:from-amber-600 hover:to-amber-700 transition-all whitespace-nowrap cursor-pointer"
            >
              Ver Nuestra Flota
            </a>
            <a
              href="/contacto"
              className="bg-white/10 text-white px-8 py-4 rounded-full font-bold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              Contáctanos
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
